import React, {Fragment, useEffect, useState} from "react";
import {fetchPostsRecent} from "../../../redux/actions";
import {Card, Image, Loader} from "semantic-ui-react";
import {APP} from "../../../constants";
import {Link} from "react-router-dom";
import moment from 'moment';
import {FormattedMessage} from "react-intl";

const Post = ({post, path}) => {

    const {id, slug, title, category_id, created_at} = post;

    const image = APP.API_URL + '/files/posts/image/' + post.image.replace('big', 'small');
    const created = moment(created_at);

    return (
        <div>
            <Link
                to={`${path}/read/${id}/${slug}?category=${category_id}`}
            >
                <Image
                    floated='left'
                    size='tiny'
                    src={image}
                />
                <strong>{title}</strong>
                <div>
                    <small>{created.format('MMM D, Y')}</small>
                </div>
            </Link>
        </div>
    );
};

export const Recent = ({from, city, path, category, author}) => {

    const [posts, setPosts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {

            // clean items
            setPosts([]);

            // start loading
            setIsLoading(true);

            try {

                // get posts
                const result = await fetchPostsRecent(city.id, category, from);

                // set posts
                setPosts(result.data);

            } catch (e) {

                // show errors
                console.log('error', e);
            }

            // stop loading
            setIsLoading(false);
        };

        // noinspection JSIgnoredPromiseFromCall
        fetchData();

    }, [city.id, category]);

    return (
        <Fragment>
            <h3 className="ui header">
                <FormattedMessage id={author.length > 0 ? "Colunas" : "Recentes"}/> {author}
            </h3>

            <Card.Group className={'post-recent'} style={{margin: 'inherit'}}>
                <Loader
                    active={isLoading}
                    inline={true}
                />
                {
                    posts.map((post) => {
                        return (
                            <Post
                                key={`recent-post-${post.id}`}
                                post={post}
                                path={path}
                            />
                        );
                    })
                }
            </Card.Group>
        </Fragment>
    );
};

